/* Makes the theme's native Content tabs easy to move through (used by the
   birth-flower month finder): swipe the content left/right, prev/next arrows
   with the current tab's name, keyboard arrows, a one-row scrollable button
   bar on phones that keeps the active month in view, and a short slide-in.
   It only clicks the theme's own tab buttons, so the section stays fully
   editable in the theme editor. */
(function () {
  function enhance(ct) {
    if (ct.dataset.swipeReady) return;
    var btns = [].slice.call(ct.querySelectorAll(".content-tab-button"));
    var bar = ct.querySelector(".content-tabs__buttons");
    var box = ct.querySelector(".content-tabs__tabs");
    if (btns.length < 3 || !bar || !box) return;
    ct.dataset.swipeReady = "1";
    bar.classList.add("ct-scroll");
    box.classList.add("ct-swipe");

    var nav = document.createElement("div");
    nav.className = "ct-nav";
    nav.innerHTML =
      '<button type="button" class="ct-nav__btn" data-d="-1" aria-label="Previous">&larr;</button>' +
      '<span class="ct-nav__label" aria-live="polite"></span>' +
      '<button type="button" class="ct-nav__btn" data-d="1" aria-label="Next">&rarr;</button>';
    box.parentNode.insertBefore(nav, box);
    var label = nav.querySelector(".ct-nav__label");

    function idx() {
      var i = btns.findIndex(function (b) {
        return b.classList.contains("content-tab-button--active");
      });
      return i < 0 ? 0 : i;
    }
    function nameOf(i) {
      var tab =
        ct.querySelector(
          '.content-tab[data-index="' + btns[i].dataset.index + '"]',
        ) || ct.querySelectorAll(".content-tab")[i];
      var h = tab && tab.querySelector("h2, h3");
      var t = h
        ? h.textContent.split(":")[0].trim()
        : btns[i].textContent.trim();
      return t || btns[i].textContent.trim();
    }
    function sync(dir) {
      var i = idx(),
        b = btns[i];
      label.textContent = nameOf(i) + " · " + (i + 1) + " of " + btns.length;
      if (bar.scrollWidth > bar.clientWidth + 2) {
        bar.scrollTo({
          left: b.offsetLeft - (bar.clientWidth - b.offsetWidth) / 2,
          behavior: "smooth",
        });
      }
      if (dir) {
        var tab = ct.querySelector(".content-tab--active");
        if (tab) {
          tab.classList.remove("ct-in-l", "ct-in-r");
          void tab.offsetWidth;
          tab.classList.add(dir > 0 ? "ct-in-r" : "ct-in-l");
        }
      }
    }
    function go(i, dir) {
      var n = btns.length;
      ct._dir = dir;
      btns[((i % n) + n) % n].click();
    }
    btns.forEach(function (b, i) {
      b.addEventListener("click", function () {
        var before = ct.dataset.lastIdx ? +ct.dataset.lastIdx : i;
        var dir = ct._dir || (i === before ? 0 : i > before ? 1 : -1);
        ct._dir = 0;
        ct.dataset.lastIdx = i;
        setTimeout(function () { sync(dir); }, 0);
      });
    });
    nav.addEventListener("click", function (e) {
      var b = e.target.closest(".ct-nav__btn");
      if (b) go(idx() + +b.dataset.d, +b.dataset.d);
    });
    bar.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") {
        go(idx() + 1, 1);
        btns[idx()].focus();
        e.preventDefault();
      }
      if (e.key === "ArrowLeft") {
        go(idx() - 1, -1);
        btns[idx()].focus();
        e.preventDefault();
      }
    });

    // swipe (touch) or drag (mouse) across the content
    var down = false,
      sx = 0,
      sy = 0;
    box.addEventListener("pointerdown", function (e) {
      if (e.target.closest("a, button")) return;
      down = true;
      sx = e.clientX;
      sy = e.clientY;
    });
    box.addEventListener("pointerup", function (e) {
      if (!down) return;
      down = false;
      var dx = e.clientX - sx,
        dy = e.clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3)
        go(idx() + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
    });
    box.addEventListener("pointercancel", function () {
      down = false;
    });
    box.querySelectorAll("img").forEach(function (img) {
      img.setAttribute("draggable", "false");
    });

    ct.dataset.lastIdx = idx();
    sync(0);
  }
  // Buttons linking to "#create-yours" open the page's customizer button (keeps its market-aware URL);
  // without one on the page they scroll to the product form instead.
  document.addEventListener("click", function (e) {
    var a = e.target.closest('a[href="#create-yours"]');
    if (!a) return;
    var main = document.querySelector('a[id^="customizer-btn-"]');
    e.preventDefault();
    if (main && main.href) window.location.href = main.href;
    else {
      var info = document.querySelector('[id^="ProductInfo-"], product-info, .product__info-container');
      if (info) info.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });
  // Product pages that buy through the customizer have no regular Add-to-cart button, so the
  // theme's sticky bar ("after scrolling past the button") never appears. Show it once the
  // customizer button has scrolled out of view above, hide it again when it is back on screen.
  function stickyForCustomizer() {
    var bar = document.querySelector("sticky-atc[data-after-scroll]");
    var cta = document.querySelector('a[id^="customizer-btn-"]');
    if (!bar || !cta || bar.dataset.pocWatch || !("IntersectionObserver" in window)) return;
    bar.dataset.pocWatch = "1";
    bar.style.transition = "transform 0.3s ease";
    var past = false;
    var seen = new Set();
    // In-page "#create-yours" buttons (month tabs, how-it-works) do the same job as the bar,
    // so while one is on screen the bar stays hidden (no two buttons stacked on top of each other).
    function liveCtaOnScreen() {
      var on = false;
      seen.forEach(function (el) {
        var tab = el.closest(".content-tab");
        if (tab && !tab.classList.contains("content-tab--active")) return;
        if (getComputedStyle(el).visibility === "hidden") return;
        on = true;
      });
      return on;
    }
    function apply() {
      var show = past && !liveCtaOnScreen();
      bar.style.setProperty("transform", show ? "translateY(0)" : "translateY(100%)", "important");
    }
    new IntersectionObserver(function (es) {
      var e = es[0];
      past = !e.isIntersecting && e.boundingClientRect.top < 0;
      apply();
    }).observe(cta);
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) seen.add(e.target);
        else seen.delete(e.target);
      });
      apply();
    });
    document.querySelectorAll('a[href="#create-yours"]').forEach(function (a) {
      io2.observe(a);
    });
    document.addEventListener("click", function (e) {
      if (e.target.closest(".content-tab-button")) setTimeout(apply, 350);
    });
  }
  function boot() {
    document.querySelectorAll("content-tabs").forEach(enhance);
    stickyForCustomizer();
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
